export default __webpack_public_path__ + "static/media/szafy10.562b6726.jpg";